import Rails from "@rails/ujs";
import {Controller} from "stimulus";
import QrScanner from "qr-scanner";

export default class extends Controller {
  static targets = [
    "statusText",
    "selectForm",
    "form",
    "firstStepDiv",
    "secondStepDiv",
    "thirdStepDiv",
    "fourthStepDiv",
    "lastStepDiv",
    "childDataDiv",
    "bankDataDiv",
    "additionalDeliveryAddress",
    "politicallyExposedPerson",
    "boPoliticallyExposedPerson",
    "additionalAddress",
    "deliveryAddressFields",
    "formObject",
    "partnerCard",
    "amount",
    "customAmount",
    "customMonthlyAmountRadio",
    "customMonthlyAmountInput",
    "customPaymentFee",
    "contractType",
    "moneyNe",
    "moneyNj",
    "moneyNb",
    "oneTimePayment",
    "setupFeeTotalDiv",
    "emailInput",
    "kycMonthlyPaymentInput",
    "kycOneTimePaymentInput",
    "customerModeDiv",
    "existingCustomerFields",
    "newCustomerFields",
    "bankDataModeDiv",
    "newWalletFields",
    "novemWalletOrdered",
    "hasWalletFields",
    "selectWalletFields",
    "existingBankDataFields",
    "newBankDataFields",
    "blockchainProductPrice",
    "blockchainTotalAmountInput",
    "blockchainQuantityInput",
    "blockchainProductId",
    "blockchainTitle",
    "blockchainLabelAgb",
    "blockchainBundleQuantity",
    "blockchainBundleFreezePrice",
    "blockchainLabelPurchase",
    "commissionPercent",
    "walletDataForm",
    "cryptocurrencyDiv"
  ];

  static value = {
    formObject: Object,
    identificationDocumentUrl: String,
    contractType: String,
    monthlyAmount: Number,
    purchaseLimitData: Object
  };

  connect() {
    if (document.querySelector("[name='contract[type]'][checked]")) {
      this.contractTypeValue = document.querySelector("[name='contract[type]'][checked]").value;
      this.updateContentOnContractType();
    }

    // --- GA Tracking Step 1 ---
    this.trackFunnelStep("step_1_partner_selection");

    // Disable back button
    if(window.location.href.includes("contracts/new")) {
      history.pushState(null, null, null);
      window.addEventListener("popstate", function() {
        history.pushState(null, null, null);
      });
    }

    // Disable leave alert on submit button
    $("#contract_form").submit(() => {
      window.onbeforeunload = null;

      // --- GA Conversion ---
      const contractType = this.contractTypeValue || document.querySelector("[name='contract[type]']:checked")?.value;
      window.analytics?.trackContractCreated(contractType);
    });

    if(window.location.href.includes("/blockchain_calculations") && this.contractTypeValue === "NvmContract") {
      this.hideNeedWalletAddress();
      this.customerWalletAddress();
    } else if (window.location.href.includes("/blockchain_calculations")) {
      this.hideWalletAddress();
    } else {
      this.updateDenominationOptions();
    }
  }

  trackFunnelStep(step) {
    const contractType = this.contractTypeValue || document.querySelector("[name='contract[type]']:checked")?.value;
    window.analytics?.trackContractFunnel(step, contractType);
  }

  hideWalletAddress() {
    const walletDataForm = document.querySelector("[data-target~='admin--contract.walletDataForm']");
    walletDataForm?.classList.add("d-none");
  }

  hideNeedWalletAddress() {
    const needWalletAddress = document.getElementById("contract_need_wallet_address_0");
    const needWalletAddressTrue = document.getElementById("contract_need_wallet_address_true");
    needWalletAddressTrue?.click();
    if (needWalletAddress) {
      needWalletAddress.parentElement.classList.add("d-none");
    }
  }

  calculateBlockchainAmount() {
    const blockchainQuantity = parseFloat(this.blockchainQuantityInputTarget.value)|| 1;
    const tokenPrice = parseFloat(this.blockchainProductPriceTarget.innerText.replace(/\./g, "").replace(",", "."));
    const blockchainAmount = blockchainQuantity.toFixed(4) * tokenPrice;

    document.getElementById("amount_field").value = blockchainAmount.toString().replace(".", ",");

    if (this.isPremiumContract()) {
      const commissionPercent = parseInt(this.commissionPercentTarget.value);
      const commissionValue = (blockchainAmount / 100) * commissionPercent;

      document.querySelector("#contract_premium_commission_commission_value").value = commissionValue.toFixed(2);
      this.blockchainTotalAmountInputTarget.value = this.numberWithDelimiter(blockchainAmount + commissionValue);
    } else {
      this.blockchainTotalAmountInputTarget.value = this.numberWithDelimiter(blockchainAmount);
    }

    this.calculateBlockchainQuantity(null, false);
    this.isBlockchainAmountValid();
  }

  calculateBlockchainQuantity(e, changeQuantity=true) {
    const totalAmount = parseFloat(this.blockchainTotalAmountInputTarget.value.replace(/\./g, "").replace(",", ".")) || 0;
    const tokenPrice = parseFloat(this.blockchainProductPriceTarget.innerText.replace(/\./g, "").replace(",", "."));
    this.blockchainBundleFreezePriceTarget.value = Math.round(tokenPrice * 100);

    if (this.isPremiumContract()) {
      const commissionPercent = parseInt(this.commissionPercentTarget.value);
      const blockchainQuantity = (100 * totalAmount) / (tokenPrice * (100 + commissionPercent));
      const blockchainAmount = blockchainQuantity.toFixed(4) * tokenPrice;

      document.querySelector("#contract_premium_commission_commission_value").value = (totalAmount - blockchainAmount).toFixed(2);
      if (changeQuantity === true) {
        this.blockchainQuantityInputTarget.value = blockchainQuantity.toFixed(4);
      }
      document.getElementById("amount_field").value = blockchainAmount.toString().replace(".", ",");
    } else {
      const blockchainQuantity = (totalAmount / tokenPrice);
      if (changeQuantity === true) {
        this.blockchainQuantityInputTarget.value = blockchainQuantity.toFixed(4);
      }
      document.getElementById("amount_field").value = totalAmount.toString().replace(".", ",");
    }

    this.isBlockchainAmountValid();
  }

  calculatePremiumCommission() {
    this.calculateBlockchainAmount();
  }

  isPremiumContract() {
    const premiumContracts = ["NnnPlusContract", "NxagPlusContract", "NptPlusContract", "NpdPlusContract"];
    return premiumContracts.includes(this.contractTypeValue);
  }

  isBlockchainAmountValid() {
    const validContracts = ["NnnContract", "NvmContract", "NlpContract", "NnnPlusContract", "NxagPlusContract", "NptPlusContract", "NpdPlusContract"];
    if (!validContracts.includes(this.contractTypeValue)) return true;

    const minTokenTotalAmount = 100;
    const blockchainQuantity = parseFloat(this.blockchainQuantityInputTarget.value).toFixed(4);
    const tokenPrice = parseFloat(this.blockchainProductPriceTarget.innerText.replace(/\./g, "").replace(",", "."));
    const totalAmount = blockchainQuantity * tokenPrice;
    if (totalAmount <= minTokenTotalAmount) {
      this.showError(this.blockchainQuantityInputTarget, `Kaufbetrag (${blockchainQuantity}Stück * ${tokenPrice}€) muss mehr als 100€ sein`);
    } else {
      this.clearError(this.blockchainQuantityInputTarget);
    }
    return totalAmount > minTokenTotalAmount;
  }

  showError(inputElement, message) {
    inputElement.classList.add("is-invalid");
    const errorElement = $("#tokenTotalAmountError");
    errorElement.remove();
    $(inputElement).after(`<div id='tokenTotalAmountError' class='invalid-feedback'>${message}</div>`);
  }

  clearError(inputElement) {
    inputElement.classList.remove("is-invalid");
    $("#tokenTotalAmountError").remove();
  }

  selectCustomer(event) {
    event.preventDefault();
    if(window.location.href.includes("/blockchain_calculations")) {
      this.customerWalletAddress();
    }
  }

  formToggler(event) {
    this.resetAllStatusText();
    this.closeAllForms();
    if(event.type === "mouseover") {
      this.activateForm();
    }
  }

  activateForm() {
    this.selectFormTarget.classList.remove("d-none");
    this.statusTextTarget.classList.add("d-none");
  }

  returnToFirstStep(event) {
    event.preventDefault();
    document.querySelectorAll(".second-step").forEach(e => e.classList.add("d-none"));
    document.querySelectorAll(".partner-card-title").forEach(e => e.classList.add("d-none"));
    document.querySelectorAll(".first-step").forEach(e => e.classList.remove("d-none"));
    this.scrollToTop();
  }

  showSecondStep(event) {
    event.preventDefault();
    const observer = new MutationObserver((mutationsList) => {
      for (let mutation of mutationsList) {
        if (mutation.type === "childList" || mutation.type === "characterData") {
          const span = document.getElementById("select2-contract_customer_attributes_user_attributes_appeal-container");
          const firma = document.getElementById("company_name_firma");
          if (span.innerText === "Firma") {
            firma.classList.remove("d-none");
          } else {
            firma.classList.add("d-none");
          }
        }
      }
    });

    const config = { characterData: true, childList: true, subtree: true };
    observer.observe(document.querySelector("#select2-contract_customer_attributes_user_attributes_appeal-container"), config);

    document.querySelectorAll(".second-step").forEach(e => e.classList.remove("d-none"));
    document.querySelectorAll(".partner-card-title").forEach(e => e.classList.remove("d-none"));
    document.querySelectorAll(".first-step").forEach(e => e.classList.add("d-none"));
    this.scrollToTopWindow();
    if (window.location.href.includes("/blockchain_calculations")) {
      this.initQr(document.querySelector("#videoQr"), $("#contract_wallet_address_address"), $("#qrStart"), $("#qrStop"));
    }
    this.setPartnerToSecondStep();
    this.loadParentData();

    // --- GA Tracking Step 2 ---
    this.trackFunnelStep("step_2_customer_details");

    window.onbeforeunload = function() {
      return window.i18n.t("view.admin.contract_controller.leave_this_page");
    };
  }

  returnToSecondStep(event) {
    event.preventDefault();
    document.querySelectorAll(".second-step").forEach(e => e.classList.remove("d-none"));
    document.querySelectorAll(".third-step").forEach(e => e.classList.add("d-none"));
    this.scrollToTop();
  }

  async showThirdStep(event) {
    event.preventDefault();
    this.fillFieldsInputs();
    if(this.invalidInputs === 0 && await this.isEmailUnique()) {
      await this.handleBankData();
      await this.handleProduct();
      document.querySelectorAll(".third-step").forEach(e => e.classList.remove("d-none"));
      document.querySelectorAll(".second-step").forEach(e => e.classList.add("d-none"));
      this.scrollToTopWindow();
      if (this.isPremiumContract()) {
        document.querySelectorAll(".premium-commission-block").forEach(e => e.classList.remove("d-none"));
      }
    } else {
      this.scrollToInvalidInput();
    }
    this.updateContentOnContractType();
    if (this.isPremiumContract()) {
      document.querySelector("#contract_premium_commission_commission_value").type = "password";
    }

    // --- GA Tracking Step 3 ---
    this.trackFunnelStep("step_3_contract_configuration");
  }

  async getCustomersKyc(customer_id) {
    return await fetch(`/customers/customers_kyc.json?customer_id_for_kyc=${customer_id}`).then(response => response.json());
  }

  async getCustomersBankData(customer_id) {
    const queryString = window.location.search;
    const contract_type = queryString.split("=")[1];
    return await fetch(`/customers/customers_bank_data.json?customer_id_for_bank_data=${customer_id}&type_of_contract_bank_data=${contract_type}`).then(response => response.json());
  }

  fillFieldsInputs() {
    let customer = document.getElementById("select2-contract_customer_id-container").innerText;
    const customer_id = customer.split(" ")[0].split("#")[1];
    let new_customer = document.getElementById("contract_existing_customer_or_new_new").checked;
    if (!new_customer) {
      this.getCustomersKyc(customer_id).then(r => {
        if (!r) return;

        for (const [key, value] of Object.entries(r)) {
          const str = "id created_at updated_at contract_id job_start_date employment_type capital" +
              "monthly_payment_input_cents one_time_payment_input_cents annual_salary legal_transaction" +
              "capital_from other_capital monthly_payment one_time_payment one_time_payment_input monthly_payment_input";
          if(value && !str.includes(key)) {
            let name_of_input = `contract[kyc_attributes][${key}]`;
            let array_of_elements = document.getElementsByName(name_of_input);
            let element = array_of_elements[array_of_elements.length - 1];
            let value_if_true = 1;
            if (value === true) {
              element.value = value_if_true;
              element.checked = true;
            } else {
              element.value = value;
            }
          }
        }
        if (r["job_start_date"]) {
          let dates = r["job_start_date"].split("-");
          this.fillDate(dates);
        }
        if (r["employment_type"]) {
          this.fillEmploymentType(r["employment_type"]);
        }
        if (r["annual_salary"]) {
          this.fillAnnualSalary(r["annual_salary"]);
        }
      });
      this.getCustomersBankData(customer_id).then(r => {
        if (!r) return;

        const str = "enc_bank_name enc_iban enc_bic enc_account_holder";
        const wordsArray = str.split(" ");
        wordsArray.forEach(word => {
          let name_of_input = `contract[bank_datum_attributes][${word}]`;
          let array_of_elements = document.getElementsByName(name_of_input);
          let element = array_of_elements[array_of_elements.length - 1];
          element.value = "";
        });
        for (const [key, value] of Object.entries(r)) {
          if(value && str.includes(key)) {
            let name_of_input = `contract[bank_datum_attributes][${key}]`;
            let array_of_elements = document.getElementsByName(name_of_input);
            let element = array_of_elements[array_of_elements.length - 1];
            if (element) {
              element.value = value;
            }
          }
        }
      });
    }
  }

  fillEmploymentType(employment_types) {
    const types = {
      "employed": 1,
      "self_employed": 2,
      "civil_servant": 3,
      "pensioner": 4,
    };
    let employment_element = document.getElementsByName("contract[kyc_attributes][employment_type]")[types[employment_types]];
    if (!("checked" in employment_element)) {
      employment_element.setAttribute("checked", "checked");
    }
    employment_element.checked = true;
  }

  fillAnnualSalary(annual_salary) {
    const salaries = {
      "less_18k_euro": 1,
      "less_30k_euro": 2,
      "less_60k_euro": 3,
      "over_60k_euro": 4,
    };
    let annual_salary_element = document.getElementsByName("contract[kyc_attributes][annual_salary]")[salaries[annual_salary]];
    if (!("checked" in annual_salary_element)) {
      annual_salary_element.setAttribute("checked", "checked");
    }
    annual_salary_element.checked = true;
  }

  fillDate(dates) {
    document.getElementById("contract_kyc_attributes_job_start_date_1i").value = parseInt(dates[0], 10);
    document.getElementById("contract_kyc_attributes_job_start_date_2i").value = parseInt(dates[1], 10);
    document.getElementById("contract_kyc_attributes_job_start_date_3i").value = parseInt(dates[2], 10);
    document.getElementById("select2-contract_kyc_attributes_job_start_date_1i-container").textContent = dates[0];
    document.getElementById("select2-contract_kyc_attributes_job_start_date_2i-container").textContent = dates[1];
    document.getElementById("select2-contract_kyc_attributes_job_start_date_3i-container").textContent = dates[2];
  }

  returnToThirdStep(event) {
    event.preventDefault();

    // Clear cached purchase limit data to force re-check when proceeding forward again
    this.purchaseLimitDataValue = null;

    // Reset KYC form visibility to ensure fresh state
    this.resetKycFormVisibility();

    document.querySelectorAll(".fourth-step").forEach(e => e.classList.add("d-none"));
    document.querySelectorAll(".third-step").forEach(e => e.classList.remove("d-none"));
    this.scrollToTop();
  }

  async showFourthStep(event) {
    event.preventDefault();
    const alert = document.getElementById("alertForGoldProducts");
    if (this.invalidInputs === 0 && this.isBlockchainAmountValid() && (!alert || alert.classList.contains("d-none"))) {
      // Check if we should skip KYC step for blockchain contracts
      if (window.location.href.includes("/blockchain_calculations")) {
        // For existing customers, refresh purchase limit data with current amount
        const existingCustomer = document.getElementById("contract_existing_customer_or_new_existing");
        if (existingCustomer && existingCustomer.checked) {
          await this.checkCustomerPurchaseLimit();
        }
        this.handleKycRequirement();
      }

      document.querySelectorAll(".fourth-step").forEach(e => e.classList.remove("d-none"));
      document.querySelectorAll(".third-step").forEach(e => e.classList.add("d-none"));
      this.scrollToTopWindow();
    } else {
      this.scrollToInvalidInput();
    }

    // --- GA Tracking Step 4 ---
    this.trackFunnelStep("step_4_kyc_data");
  }

  handleKycRequirement() {
    const existingCustomer = document.getElementById("contract_existing_customer_or_new_existing");
    const PURCHASE_LIMIT = 10000.00; // €10,000 purchase limit

    // Check if current contract amount exceeds €10,000
    // If so, ALWAYS show KYC form regardless of customer type or past payment history
    if (this.hasBlockchainTotalAmountInputTarget) {
      const currentAmount = parseFloat(this.blockchainTotalAmountInputTarget.value.replace(/\./g, "").replace(",", ".")) || 0;

      // If current contract Kaufsumme is > €10,000, ensure KYC form is visible
      if (currentAmount > PURCHASE_LIMIT) {
        // Explicitly ensure KYC form is visible (remove any "not required" messages)
        this.resetKycFormVisibility();
        return;
      }
    }

    // If contract amount is <= €10,000, check customer type
    const isNewCustomer = !existingCustomer || !existingCustomer.checked;

    if (isNewCustomer) {
      // For new customers with contract amount <= €10,000, hide KYC form
      // (new customers have no past payments, so they're automatically within limit)
      this.hideKycFormAndShowMessage();
      return;
    }

    // For existing customers with contract amount <= €10,000, check purchase limit based on past payments
    if (this.purchaseLimitDataValue) {
      const kycRequired = this.purchaseLimitDataValue.kyc_required;

      // Hide KYC form if customer doesn't require KYC (either has full KYC or is within limit)
      if (!kycRequired) {
        this.hideKycFormAndShowMessage();
      }
    }
  }

  hideKycFormAndShowMessage() {
    const kycContainer = document.querySelector(".fourth-step .contract-admin-form");
    if (kycContainer) {
      // Check if message already exists to avoid duplicates
      if (kycContainer.querySelector(".kyc-not-required-message")) {
        return;
      }

      // Find and hide the KYC form wrapper
      const kycFormWrapper = kycContainer.querySelector(".kyc-form-wrapper");
      if (kycFormWrapper) {
        kycFormWrapper.style.display = "none";

        // DISABLE all form inputs so they're not submitted
        kycFormWrapper.querySelectorAll("input, select, textarea").forEach(field => {
          field.disabled = true;
        });
      }

      // Add info message
      const messageDiv = document.createElement("div");
      messageDiv.className = "alert alert-info mt-3 kyc-not-required-message";
      messageDiv.innerHTML = `
        <h4>KYC-Daten nicht erforderlich</h4>
        <p>Dieser Kunde hat bereits vollständige KYC-Daten oder liegt innerhalb des Kauflimits von €10.000 in den letzten 3 Monaten.</p>
      `;

      // Find the header and insert message after it
      const header = kycContainer.querySelector("span.font-semibold");
      if (header) {
        header.after(messageDiv);
      } else {
        kycContainer.appendChild(messageDiv);
      }
    }
  }

  goldProductsComb() {
    let checkSum = 0;
    const alert = document.getElementById("alertForGoldProducts");
    if (document.getElementById("contract_delivery_ex_20").checked) {
      checkSum = 20;
    } else if (document.getElementById("contract_delivery_ex_50").checked) {
      checkSum = 50;
    }
    let sumCount = 0;
    let fullSum = 0;
    const count_of_products = document.getElementsByName("contract[denomination_quantity][]");
    count_of_products.forEach((count, index) => {
      if (!isNaN(parseFloat(count.value)) && document.getElementsByName("contract[denomination_product][]")[index].checked) {
        sumCount = parseInt(count.value);
        fullSum += sumCount * this.countOfProduct(document.getElementsByName("contract[denomination_product][]")[index]);
      }
    });
    if (fullSum !== checkSum) {
      alert.classList.remove("d-none");
    } else {
      alert.classList.add("d-none");
    }
  }

  countOfProduct(product) {
    return parseFloat(product.parentElement.childNodes[1].innerHTML.split(" ")[0].split("g")[0].replace(/,/g, "."));
  }

  returnToFourthStep(event) {
    this.scrollToTop();
    event.preventDefault();

    // Reset KYC form visibility before re-applying logic
    this.resetKycFormVisibility();
      
    document.querySelectorAll(".fourth-step").forEach(e => e.classList.remove("d-none"));
    document.querySelectorAll(".last-step").forEach(e => e.classList.add("d-none"));

    // Re-apply KYC requirement logic
    if (window.location.href.includes("/blockchain_calculations")) {
      this.handleKycRequirement();
    }
  }

  resetKycFormVisibility() {
    // Remove any existing KYC not required message
    document.querySelectorAll(".kyc-not-required-message").forEach(e => e.remove());

    // Show all KYC form elements again
    const kycContainer = document.querySelector(".fourth-step .contract-admin-form");
    if (kycContainer) {
      const kycFormWrapper = kycContainer.querySelector(".kyc-form-wrapper");
      if (kycFormWrapper) {
        kycFormWrapper.style.display = "";

        // RE-ENABLE all form inputs
        kycFormWrapper.querySelectorAll("input, select, textarea").forEach(field => {
          field.disabled = false;
        });
      }

      const allChildren = Array.from(kycContainer.children);
      allChildren.forEach(child => {
        child.style.display = "";
      });
    }
  }

  async showLastStep(event) {
    event.preventDefault();
    if (this.invalidInputs === 0) {
      await this.loadPreview();
      document.querySelectorAll(".last-step").forEach(e => e.classList.remove("d-none"));
      document.querySelectorAll(".fourth-step").forEach(e => e.classList.add("d-none"));
      this.scrollToTopWindow();
    } else {
      this.scrollToInvalidInput();
    }

    // --- GA Tracking Step 5 ---
    this.trackFunnelStep("step_5_preview");
  }

  updateDenominationOptions() {
    if (document.querySelector("[name='contract[delivery_ex]']:checked")) {
      const delivery_ex = document.querySelector("[name='contract[delivery_ex]']:checked").value;
      switch(delivery_ex) {
      case "20": {
        const options_to_show = ["1 x 20g", "20 x 1g", "2 x 10g", "4 x 5g", "5 x 1g 1 x 5g 1 x 10g"];
        this.toggleDenominationOptions(options_to_show);
        break;
      }
      case "50": {
        const options_to_show = ["50 x 1g", "10 x 5g", "5 x 10g", "20 x 1g 2 x 5g 2 x 10g", "1 x 50g"];
        this.toggleDenominationOptions(options_to_show);
        break;
      }
      }
    }
  }

  toggleDenominationOptions(options_to_show) {
    const all_options = ["1 x 20g", "20 x 1g", "2 x 10g", "4 x 5g", "5 x 1g 1 x 5g 1 x 10g", "50 x 1g", "10 x 5g", "5 x 10g", "20 x 1g 2 x 5g 2 x 10g", "1 x 50g"];
    let options_to_hide = all_options.filter(option => !options_to_show.includes(option));

    options_to_hide.forEach((o) => {$(`[name='contract[denomination]'][value='${o}']`).parent().addClass("d-none");});
    options_to_show.forEach((o) => {$(`[name='contract[denomination]'][value='${o}']`).parent().removeClass("d-none");});

    $(`[name='contract[denomination]'][value='${options_to_show[0]}']`).prop("checked", true);
  }

  async handleBankData() {
    const el = $("[name='contract[existing_customer_or_new]']:checked");
    if (el.val() === "new") {
      $("#contract_existing_bank_data_or_new_new").checked = true;
      this.bankDataModeDivTarget.classList.add("d-none");
      this.existingBankDataFieldsTarget.classList.add("d-none");
      this.newBankDataFieldsTarget.classList.remove("d-none");
    } else {
      this.bankDataModeDivTarget.classList.remove("d-none");
      await this.loadExistingCustomerBankData();
    }
  }

  async handleProduct() {
    const validContracts = ["NnnContract", "NvmContract", "NlpContract", "NnnPlusContract", "NxagPlusContract", "NptPlusContract", "NpdPlusContract"];
    if (!validContracts.includes(this.contractTypeValue)) return;

    let csrfToken = document.head.querySelector("meta[name=\"csrf-token\"]") ? document.head.querySelector("meta[name=\"csrf-token\"]").content : "";

    if(csrfToken !== null) {
      await $.ajax({
        url: "/contracts/fetch_product_data",
        type: "GET",
        data: { contract_type: this.contractTypeValue },
        headers: {
          "X-CSRF-TOKEN": csrfToken,
          "Content-Type": "application/json",
        },
        success: (response) => {
          this.blockchainProductIdTarget.value = response.id;
          this.blockchainProductPriceTarget.innerHTML = ` ${this.numberWithDelimiter(response.price)}€`;
          this.blockchainTitleTarget.innerHTML = response.title.replace(/Token/gi, "").trim();
          this.blockchainQuantityInputTarget.dataset.price = response.price;
          this.blockchainLabelAgbTarget.innerHTML = response.label_agb;
          this.blockchainLabelPurchaseTarget.innerHTML = response.label_blockchain_purchase;
          this.calculateBlockchainAmount();
        }
      });
    }
  }

  // return the amount of invalid inputs on current step
  get invalidInputs() {
    const invalidInputs = [];
    const blockhainInput = document.getElementById("blockchain-input");
    if(blockhainInput && blockhainInput.classList.contains("is-invalid")) {
      invalidInputs.push(blockhainInput);
    }

    // Check if KYC form is hidden
    const kycFormHidden = document.querySelector(".kyc-not-required-message") !== null;
    
    document.querySelectorAll("input.required, textarea.required, select.required, div.form-group.upload.required button").forEach(function(item){
      // Skip validation for KYC fields if KYC form is hidden
      if (kycFormHidden) {
        const kycContainer = document.querySelector(".fourth-step .contract-admin-form");
        if (kycContainer && kycContainer.contains(item) && item.offsetParent === null) {
          return;
        }
      }
        
      if(item.offsetParent !== null && item.value.trim() === "" || item.type === "checkbox" && item.checked === false && item.nextSibling && item.nextSibling.offsetParent !== null) {
        item.classList.add("is-invalid");
        invalidInputs.push(item);
      } else {
        item.classList.remove("is-invalid");
      }
    });

    const email_confirmation = document.getElementById("email_confirmation");
    if (email_confirmation.offsetParent !== null && email_confirmation.value !== this.emailInputTarget.value) {
      email_confirmation.classList.add("is-invalid");
      invalidInputs.push(email_confirmation);
    } else {
      email_confirmation.classList.remove("is-invalid");
    }

    const wallet_address_field = $(".wallet_address:visible")[0];
    if (window.location.pathname.includes("/blockchain_calculations") && wallet_address_field) {
      const web3 = new window.Web3(window.Web3.givenProvider || "ws://localhost:8545");
      const wallet_alert = document.querySelector(".customer-wallet-alert");
      const customer_id = document.getElementById("contract_customer_id");

      if (wallet_address_field && web3.utils.isAddress(wallet_address_field.value)){
        wallet_address_field.classList.remove("is-invalid");
        wallet_alert.classList.add("d-none");
        customer_id.classList.remove("is-invalid");
      } else {
        wallet_address_field.classList.add("is-invalid");
        invalidInputs.push(wallet_address_field);
        wallet_alert.classList.remove("d-none");
        customer_id.classList.add("is-invalid");
      }
    }

    return invalidInputs.length;
  }

  // scroll to first invalid input
  scrollToInvalidInput() {
    let firstInvalid = $(".is-invalid:visible:first");

    // Check if invalid element exists and has offset
    if (!firstInvalid.length || !firstInvalid.offset()) {
      return;
    }

    if ($(".wrapper.full").length) {
      let container = $(".wrapper.full");
      container.animate({
        scrollTop: firstInvalid.offset().top - container.offset().top + container.scrollTop() - 100
      }, 1000);
    } else {
      let container = $([document.documentElement, document.body]);
      container.animate({
        scrollTop: firstInvalid.offset().top - 175
      }, 1000);
    }
  }

  scrollToTop() {
    let container = $(".wrapper.full").length ? $(".wrapper.full") : $([document.documentElement, document.body]);
    container.scrollTop(0);
  }

  scrollToTopWindow() {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }

  setPartnerToSecondStep() {
    let partner_id = document.getElementById("partner_parent_id").value;
    document.getElementById("contract_partner_id").value = partner_id;
  }

  onShowAdditionalAddressClick(e) {
    e.preventDefault();
    e.target.remove();
    this.showAdditinalAddress();
  }

  onMonthlyAmountChanged(e) {
    this.monthlyAmountValue = e.currentTarget.value;
    this.oneTimePaymentTarget.value = this.getOneTimePaymentByContractType(this.monthlyAmountValue);
    this.amountTarget.value = this.getAmountByContractType(this.monthlyAmountValue);
    this.kycMonthlyPaymentInputTarget.value = this.monthlyAmountValue;
    this.kycOneTimePaymentInputTarget.value = this.amountTarget.value;
  }

  // calculate amount from contract type
  getAmountByContractType(amount) {
    if (this.contractTypeValue === "NeContract") return amount * 36 * 5;
    return 0;
  }

  // calculate one time payment from amount
  getOneTimePaymentByContractType(amount) {
    switch (this.contractTypeValue) {
    case "NeContract": {
      return amount * 36;
    }
    case "NjContract": {
      return 99;
    }
    case "NbContract": {
      return amount * 35;
    }
    }
    return 0;
  }

  showAdditinalAddress() {
    this.additionalAddressTarget.classList.remove("d-none");
  }

  onShowAdditionalDeliveryAddressClick(e) {
    e.preventDefault();
    e.target.remove();
    this.showAdditinalDeliveryAddress();
  }

  showAdditinalDeliveryAddress() {
    this.additionalDeliveryAddressTarget.classList.remove("d-none");
  }

  onDifferentDeliveryAddressChanged(e) {
    this.toggleDifferentDeliveryAddressFields(e.target.checked);
  }



  onPoliticallyExposedPersonChanged(e) {
    this.togglePoliticallyExposedPersonChanged(e.target.checked);
  }

  onBoPoliticallyExposedPersonChanged(e) {
    this.toggleBoPoliticallyExposedPersonChanged(e.target.checked);
  }

  onTransactionCompletionChanged(e) {
    if (e.currentTarget.value === "as_agent") {
      $("#contract_kyc_attributes_trading_own_bill").removeAttr("checked");
      $("#contract_kyc_attributes_trading_foreign_bill").attr("checked", "checked");
    } else {
      $("#contract_kyc_attributes_trading_foreign_bill").removeAttr("checked");
      $("#contract_kyc_attributes_trading_own_bill").attr("checked", "checked");
    }
  }

  removeWalletAddressFields() {
    this.newWalletFieldsTarget.classList.add("d-none");
  }

  showWalletAddressFields() {
    this.newWalletFieldsTarget.classList.remove("d-none");
  }

  updateNovemWalletOrdered(e) {
    const selectedElement = e.target;
    this.novemWalletOrderedTarget.value = selectedElement.dataset.novemWalletOrderedValue;
  }

  toggleHasWalletAddressFields() {
    this.selectWalletFieldsTarget.classList.toggle("d-none");
    this.hasWalletFieldsTarget.classList.toggle("d-none");
  }

  toggleDifferentDeliveryAddressFields(show) {
    this.deliveryAddressFieldsTarget.classList.toggle("d-none", !show);
  }

  togglePoliticallyExposedPersonChanged(show) {
    this.politicallyExposedPersonTarget.classList.toggle("d-none", !show);
  }

  toggleBoPoliticallyExposedPersonChanged(show) {
    this.boPoliticallyExposedPersonTarget.classList.toggle("d-none", !show);
  }

  toggleKycMonthlyPaymentInput(e) {
    if (e.target.checked) {
      this.kycMonthlyPaymentInputTarget.removeAttribute("readonly");
    } else {
      this.kycMonthlyPaymentInputTarget.setAttribute("readonly", "true");
    }
  }

  toggleKycOneTimePayment(e) {
    if (e.target.checked) {
      this.kycOneTimePaymentInputTarget.removeAttribute("readonly");
    } else {
      this.kycOneTimePaymentInputTarget.setAttribute("readonly", "true");
    }
  }

  toggleCryptocurrencySelect(event) {
    // check if "cryptocurrency" was selected
    if (event.target.value === "cryptocurrency") {
      this.cryptocurrencyDivTarget.classList.remove("d-none");
    } else {
      this.cryptocurrencyDivTarget.classList.add("d-none");
      const cryptocurrencySelect = document.getElementById("contract_cryptocurrency_id");
      if (cryptocurrencySelect) {
        cryptocurrencySelect.selectedIndex = 0;
      }
    }
  }

  resetAllStatusText() {
    document.querySelectorAll(".contract-status-text").forEach(e => e.classList.remove("d-none"));
  }

  closeAllForms(){
    document.querySelectorAll(".contract-status-select-form").forEach(e => e.classList.add("d-none"));
  }

  successHandler(response) {
    if (response.detail[0].trigger_modal) {
      const modal = document.getElementById("email-confirmation-modal");
      modal.dataset.walletEmailId = response.detail[0].contract_id;
      modal.classList.add("show");
      modal.style.display = "block";
      document.body.classList.add("modal-open");
    } else {
      this.statusTextTarget.innerHTML = response.detail[0].message;
    }
  }

  errorHandler(response, status, xhr) {
    console.error(xhr.responseText);
  }

  submitForm(e) {
    e.preventDefault();
    Rails.fire(this.formTarget, "submit");
    this.closeAllForms();
    this.statusTextTarget.className = "contract-status-text";
  }

  // handle custom input of monthly amount
  setCustomMonthlyAmount() {
    let monthlyAmount = parseFloat(this.customMonthlyAmountInputTarget.value.replace(/[^0-9.]/g, "").replace(/(\..*?)\..*/g, "1"));
    monthlyAmount = monthlyAmount ? monthlyAmount : 25;
    monthlyAmount = monthlyAmount < 25 ? 25 : monthlyAmount;
    this.customMonthlyAmountInputTarget.value = monthlyAmount;
    this.customMonthlyAmountRadioTarget.value = monthlyAmount;
    let oneTimePayment = this.getOneTimePaymentByContractType(monthlyAmount);
    let amount = this.getAmountByContractType(monthlyAmount);
    this.customPaymentFeeTarget.innerHTML = `€ ${ this.numberWithDelimiter(oneTimePayment) }`;
    this.customAmountTarget.innerHTML = `€ ${ this.numberWithDelimiter(amount) }`;
    if (this.customMonthlyAmountRadioTarget.checked) {
      this.oneTimePaymentTarget.value = oneTimePayment;
      this.amountTarget.value = amount;
      this.kycMonthlyPaymentInputTarget.value = monthlyAmount;
      this.kycOneTimePaymentInputTarget.value = oneTimePayment;
    }
  }

  clickCommissionButton(e) {
    e.preventDefault();
    const agioCommission = document.querySelector(".agio-commission");
    if (agioCommission.classList.contains("hide-button")) {
      agioCommission.classList.replace("hide-button", "show-button");
      document.querySelector(".fa-eye").classList.remove("d-none");
      document.querySelector(".fa-eye-slash").classList.add("d-none");
      document.querySelector("#contract_premium_commission_commission_value").type = "text";
    } else {
      agioCommission.classList.replace("show-button", "hide-button");
      document.querySelector(".fa-eye").classList.add("d-none");
      document.querySelector(".fa-eye-slash").classList.remove("d-none");
      document.querySelector("#contract_premium_commission_commission_value").type = "password";
    }
  }

  contractTypeChanged(event) {
    this.contractTypeValue = event.currentTarget.value;
    this.updateContentOnContractType();

    // --- GA Track Contract Type Selection ---
    this.trackFunnelStep("contract_type_selected");
  }

  updateContentOnContractType() {
    switch (this.contractTypeValue) {
    case "NeContract": {
      this.childDataDivTarget.classList.add("d-none");
      this.moneyNeTarget.classList.remove("d-none");
      this.moneyNbTarget.classList.add("d-none");
      this.moneyNjTarget.classList.add("d-none");

      this.setupFeeTotalDivTarget.classList.remove("d-none");
      this.customAmountTarget.classList.replace("d-none", "d-flex");

      this.customMonthlyAmountRadioTarget.checked = true;
      this.setCustomMonthlyAmount();

      document.getElementById("agb_link").href = `${window.location.origin}/files/Vertrag_Novem_${this.contractTypeValue.substring(0, 2).toUpperCase()}_AGB.pdf`;
      window.history.replaceState(null, null, "?contract_type=NeContract");
      break;
    }
    case "NjContract": {
      this.childDataDivTarget.classList.remove("d-none");
      this.moneyNjTarget.classList.remove("d-none");
      this.moneyNeTarget.classList.add("d-none");
      this.moneyNbTarget.classList.add("d-none");

      this.setupFeeTotalDivTarget.classList.add("d-none");
      this.customAmountTarget.classList.replace("d-flex", "d-none");

      this.customMonthlyAmountRadioTarget.checked = true;
      this.setCustomMonthlyAmount();

      document.getElementById("agb_link").href = `${window.location.origin}/files/Vertrag_Novem_${this.contractTypeValue.substring(0, 2).toUpperCase()}_AGB.pdf`;
      window.history.replaceState(null, null, "?contract_type=NjContract");
      break;
    }
    case "NbContract": {
      this.childDataDivTarget.classList.add("d-none");
      this.moneyNbTarget.classList.remove("d-none");
      this.moneyNeTarget.classList.add("d-none");
      this.moneyNjTarget.classList.add("d-none");

      this.setupFeeTotalDivTarget.classList.remove("d-none");
      this.customAmountTarget.classList.replace("d-flex", "d-none");

      this.customMonthlyAmountRadioTarget.checked = true;
      this.setCustomMonthlyAmount();

      document.getElementById("agb_link").href = `${window.location.origin}/files/Vertrag_Novem_${this.contractTypeValue.substring(0, 2).toUpperCase()}_AGB.pdf`;
      window.history.replaceState(null, null, "?contract_type=NbContract");
      break;
    }
    }
    if (document.getElementsByClassName("money-nb").count !== undefined) {
      this.customMonthlyAmountRadioTarget.checked = true;
      this.setCustomMonthlyAmount();
    }
  }

  onCustomerModeChanged() {
    if (window.location.href.includes("/blockchain_calculations")) {
      this.hideNeedWalletAddress();
    }

    this.toggleFields();

    if (!this.existingCustomerFieldsTarget.classList.contains("d-none")) {
      const customerNumber = this.getCustomerNumber();
      this.searchDocument(customerNumber);
      this.observeCustomerChange();

      // Check purchase limit for blockchain contracts
      if (window.location.href.includes("/blockchain_calculations")) {
        this.checkCustomerPurchaseLimit();
      }
    }

    if (window.location.href.includes("/blockchain_calculations") && !this.existingCustomerFieldsTarget.classList.contains("d-none")) {
      document.getElementById("contract_existing_wallet_address").innerHTML = "";
    }
  }

  toggleFields() {
    const newCustomer = document.getElementById("contract_existing_customer_or_new_new").checked;
    this.existingCustomerFieldsTarget.classList.toggle("d-none", newCustomer);
    this.newCustomerFieldsTarget.classList.toggle("d-none", !newCustomer);

    const personalData = document.getElementById("personal_data");
    const personalDataInfo = document.getElementById("info_personal_data");
    const submit = document.getElementById("for_valid_customers");

    personalData.classList.toggle("d-none", !newCustomer);
    if (newCustomer) {
      personalDataInfo.classList.add("d-none");
      submit.classList.remove("d-none");
    }
  }

  getCustomerNumber() {
    const element = document.getElementById("select2-contract_customer_id-container");
    return element.textContent.trim().split(/\s+/)[0].slice(1);
  }

  observeCustomerChange() {
    const element = document.getElementById("select2-contract_customer_id-container");
    const observer = new MutationObserver(() => {
      this.searchDocument(this.getCustomerNumber());
      if (window.location.href.includes("/blockchain_calculations")) {
        this.checkCustomerPurchaseLimit();
      }
    });

    observer.observe(element, { childList: true, subtree: true });

    if (this.existingCustomerFieldsTarget.classList.contains("d-none")) {
      observer.disconnect();
    }
  }

  async checkCustomerPurchaseLimit() {
    const customer_id = $("#contract_customer_id").val();
    if (!customer_id) return;

    let csrfToken = document.head.querySelector("meta[name=\"csrf-token\"]") ? document.head.querySelector("meta[name=\"csrf-token\"]").content : "";

    if(csrfToken !== null) {
      await $.ajax({
        url: "/contracts/check_purchase_limit",
        type: "GET",
        headers: {
          "X-CSRF-TOKEN": csrfToken,
          "Content-Type": "application/json"
        },
        data: { customer_id: customer_id },
        success: (response) => {
          this.purchaseLimitDataValue = response;
        },
        error: (error) => {
          console.error("Error checking purchase limit:", error);
        }
      });
    }
  }

  searchDocument(customerNumber) {
    $.ajax({
      url: `/contracts/identity_data_form.json?customer_id_for_searching=${customerNumber}`,
      type: "POST",
      processData: false,
      contentType: false,
      data: new FormData(document.querySelector("#contract_form")),
      dataType: "text",
      success: (response) => this.handleDocumentResponse(response)
    });
  }

  handleDocumentResponse(response) {
    // Ignore stale customer lookups after switching to a new customer.
    const newCustomer = document.getElementById("contract_existing_customer_or_new_new");
    if (newCustomer.checked) {
      document.getElementById("info_personal_data").classList.add("d-none");
      return;
    }

    // Handle empty or null response for minimal customers
    if (!response || response === "" || response === "null") {
      console.log("Empty response for customer - likely a minimal customer");
      return;
    }
      
    const [documents_present, check_customer, pending_cold_wallet] = response.split(",");
    const personal_data = document.getElementById("personal_data");
    const personal_data_info = document.getElementById("info_personal_data");
    const info_valid_customer = document.getElementById("flash_valid");
    const submit = document.getElementById("for_valid_customers");
    const needWalletAddress = document.getElementById("contract_need_wallet_address_0");
    const info_alert = document.getElementById("info_personal_data");
    const new_customer = document.getElementById("contract_existing_customer_or_new_new");

    this.toggleVisibility(documents_present === "true", [personal_data, personal_data_info]);
    if (documents_present === "false" && !new_customer.checked) {
      info_alert.classList.remove("d-none");
    }

    this.toggleVisibility(check_customer === "false", [submit], [info_valid_customer]);

    if (window.location.href.includes("/blockchain_calculations")) {
      this.toggleVisibility(pending_cold_wallet === "false", [needWalletAddress.parentElement]);
    }
  }

  toggleVisibility(condition, hideElements = [], showElements = []) {
    hideElements.forEach(el => el.classList.toggle("d-none", condition));
    showElements.forEach(el => el.classList.toggle("d-none", !condition));
  }

  onBankDataModeChanged() {
    this.existingBankDataFieldsTarget.classList.toggle("d-none");
    this.newBankDataFieldsTarget.classList.toggle("d-none");
  }

  async loadParentData() {
    const partner_id = document.getElementById("partner_parent_id").value;
    const card = document.getElementById("short-partner-card");
    if (partner_id) {
      card.innerHTML = await fetch(`/partners/${partner_id}/short_card`)
        .then(response => response.text())
        .then(html => { return html; });
    } else {
      card.innerHTML = "";
    }
  }

  // load last step data
  async loadPreview() {
    const spinner = $("#loading-spinner");
    spinner.toggleClass("d-none d-flex");

    const lastStep = document.getElementById("last_step");

    await $.ajax({
      url: "/contracts/preview",
      type: "POST",
      processData: false,
      contentType: false,
      data: new FormData(document.querySelector("#contract_form")),
      dataType: "text",
      success: (response) => {
        lastStep.innerHTML = response;
      },
      error: () => {
        alert(window.i18n.t("view.admin.contract_controller.something_went_wrong"));
      },
      complete: () => {
        spinner.toggleClass("d-none d-flex");
      }
    });

    this.loadFileCards();
    if (document.getElementById("contract_delivery_address_attributes_identification_documents")) {
      this.loadFileAddressCards();
    }
  }

  loadFileCards() {
    const files = [...document.getElementById("contract_customer_attributes_user_attributes_identification_documents").files];
    const identificationDocumentUrlValues = [];
    if (files) {
      files.forEach(file => identificationDocumentUrlValues.push(URL.createObjectURL(file)));
    }

    if (identificationDocumentUrlValues) {
      [...document.getElementsByClassName("contract-image-preview")].forEach(function (el, index) {
        if (identificationDocumentUrlValues[index]) {
          el.src = identificationDocumentUrlValues[index];
        }
      });
    } else {
      document.getElementById("id_document").remove();
    }
  }

  loadFileAddressCards() {
    if (window.location.pathname.includes("/blockchain_calculations")) {
      return true;
    }

    const files = [...document.getElementById("contract_delivery_address_attributes_identification_documents").files];
    const identificationAddressDocumentUrlValues = [];
    if (files) {
      files.forEach(file => identificationAddressDocumentUrlValues.push(URL.createObjectURL(file)));
    }

    if (identificationAddressDocumentUrlValues) {
      [...document.getElementsByClassName("contract-address-image-preview")].forEach(function (el, index) {
        if (identificationAddressDocumentUrlValues[index]) {
          el.src = identificationAddressDocumentUrlValues[index];
        }
      });
    } else {
      document.getElementById("id_address_document").remove();
    }
  }

  async loadExistingCustomerBankData() {
    const customer_id = $("#contract_customer_id").val();
    let csrfToken = document.head.querySelector("meta[name=\"csrf-token\"]") ? document.head.querySelector("meta[name=\"csrf-token\"]").content : "";

    if(csrfToken !== null) {
      await $.ajax({
        url: "/contracts/customer_bank_data",
        type: "POST",
        headers: {
          "X-CSRF-TOKEN": csrfToken,
          "Content-Type": "application/json",
        },
        data: JSON.stringify({ id: customer_id }),
        success: (response) => {
          $("#contract_bank_datum_id").empty();
          response.bank_data.forEach(bk => {
            $("#contract_bank_datum_id").append(new Option(bk.label, bk.id, false, false)).trigger("change");
          });
        }
      });
    }
  }

  // transform 1000 to 1.000,00
  numberWithDelimiter(x) {
    return x.toFixed(2).toString().replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }

  async isEmailUnique() {
    if(document.getElementById("contract_existing_customer_or_new_existing").checked) {
      return true;
    }

    let body = { email: this.emailInputTarget.value };
    let csrfToken = document.head.querySelector("meta[name=\"csrf-token\"]") ? document.head.querySelector("meta[name=\"csrf-token\"]").content : "";

    const response = await fetch(`${window.location.origin}/contracts/email_validator`, {
      method: "POST",
      headers: {
        "X-CSRF-TOKEN": csrfToken,
        "Content-Type": "application/json"
      },
      body: JSON.stringify(body),
    }).then(response => response.json());
    if (response.valid) {
      this.emailInputTarget.classList.remove("is-invalid");
      $("unique-email-error").remove();
    } else {
      this.emailInputTarget.classList.add("is-invalid");
      if (!$("#unique-email-error").length) {
        $(this.emailInputTarget).after(`<div id='unique-email-error' class='invalid-feedback'>${response.error}</div>`);
      }
    }
    return response.valid;
  }

  async customerWalletAddress() {
    const customer_id = document.getElementById("contract_customer_id").value;
    let csrfToken = document.head.querySelector("meta[name=\"csrf-token\"]") ? document.head.querySelector("meta[name=\"csrf-token\"]").content : "";

    const response = await fetch(`${window.location.origin}/customers/${customer_id}`, {
      method: "GET",
      headers: {
        "X-CSRF-TOKEN": csrfToken,
        "Content-Type": "application/json"
      },
    }).then(response => response.json());

    if (response.customer.wallet_address === null) {
      document.getElementById("contract_customer_id").classList.add("is-invalid");
      document.querySelectorAll(".customer-address-alert").forEach(e => e.classList.remove("d-none"));
    } else {
      document.getElementById("contract_customer_id").classList.remove("is-invalid");
      document.querySelectorAll(".customer-address-alert").forEach(e => e.classList.add("d-none"));
    }
  }

  initQr = (video, walletInput, startBtn, stopBtn) => {
    const qrScanner = new QrScanner(
      video,
      (result) => {
        walletInput.val(result.data);
        qrScanner.stop();
        video.style.height = "0px";
      },
      {
        highlightScanRegion: true
      }
    );

    startBtn.on("click", () => {
      video.style.height = "auto";
      qrScanner.start();
    });

    stopBtn.on("click", () => {
      video.style.height = "0px";
      qrScanner.stop();
    });
  };
}
